const root = (state) => state.contest;

export const pastContestSelector = (state) => root(state).pastContest;
export const myCustomersSelector = (state) => root(state).myCustomers;
export const contestDetailsSelector = (state) => root(state).contestDetails;
export const liveUpcomingDataSelector = (state) => root(state).liveUpcoming;
export const contestCxOrderedSelector = (state) => root(state).contestCxOrdered;
export const moreCustLoadingSelector = (state) =>
  root(state).moreCustomerLoading;
export const moreOrderedCustLoadingSelector = (state) =>
  root(state).moreOrderedCustLoading;
